export const termsAndConditionsVariableChange = (params: {
  label: string;
  linkUrl: string;
  linkText: string;
}): string => {
  const finalLabel = params.label.replace("{termsAndConditions}", `<a href=${params.linkUrl}>${params.linkText}</a>`);

  return finalLabel;
};
